import keyIn from './keyIn';

export default (map, keys) => map.filterNot(keyIn(keys));
